module.exports = __webpack_public_path__ + "assets/img/Logo-IH.6455282c.png";